import { useEffect } from "react";

//helper that fixes a minor issue with react router

function ScrollToTopOnMount() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return null;
}

export default ScrollToTopOnMount;